import { Illustration, Button } from '@kiwicom/orbit-components';
import { FormattedMessage } from 'react-intl';

import Dialog from '../Dialog';

type Props = {
  readonly isVisible: boolean;
  readonly onClose: () => void;
};

const NoBookingAccessDialog = ({ isVisible, onClose }: Props) => {
  return (
    <Dialog
      illustration={<Illustration size="extraSmall" name="NoBookings" />}
      isVisible={isVisible}
      title={
        <FormattedMessage
          id="account_v2.login.dialog.no_booking_access.title"
          defaultMessage="You don't have access to this booking"
          description="Screenshot: login.dialog.no_booking_access.title.jpg"
        />
      }
      description={
        <FormattedMessage
          id="account_v2.login.dialog.no_booking_access.description"
          defaultMessage="We're sorry, but you don't have access to this booking. Please sign in with the correct email address."
          description="Screenshot: login.dialog.no_booking_access.description.jpg"
        />
      }
      primaryAction={<Button onClick={onClose}>Continue</Button>}
    />
  );
};

export default NoBookingAccessDialog;
